<script>
import { h } from 'vue';

export default {
  name: 'RysCampusImprovementGrantIndex',

  mounted() {
    this.$router.replace('/program-grants/campus-improvement-grant/overview');
  },

  render() {
    return h('div');
  }
};
</script>
